import { LitElement, html, css, styles, repeat, utils } from '@hh/global.js'
const { visuallyHidden } = styles

class CartNostoSlideshow extends LitElement {
  static properties = {
    loading: {
      reflect: true,
    },
    title: {
      type: String,
    },
    products: {
      converter(value) {
        return JSON.parse(decodeURIComponent(value))
      },
    },
    pxClass: {
      type: String,
    },
    'atc-label': {
      type: String,
    },
    'edit-variant-label': {
      type: String,
    },
    resultId: {
      attribute: 'result-id',
      type: String,
    },
  }

  constructor() {
    super()

    this.title = ''
    this.products = []
    this.pxClass = 'nosto-cart-slideshow__px'
  }

  connectedCallback() {
    super.connectedCallback()
  }

  createRenderRoot() {
    return this
  }

  get filteredProducts() {
    return this.products.filter(
      (product) =>
        !__GLOBAL__.cart.items
          .map((i) => i.handle)
          .includes(product.url.split('/').slice(-1)[0])
    )
  }

  render() {
    return html`
      <div
        class="h4 bold no-margin nosto-cart-slideshow__title ${this
        .pxClass}"
      >
        <span class="nosto-cart-slideshow__title__inner"> ${this.title} </span>
      </div>

      <div class="body color-dark-grey text-b2 cart-nosto-slideshow">
        <div class="mini-product-cards nosto-cart-slideshow__slideshow" role="region" aria-label=" ${this.title} Carousel">
        <p class="visually-hidden">This is a  ${this.title} carousel. Use Next and Previous buttons to navigate, or jump to a slide using the slide dots.</p>
        <simple-slider data-nav-a11y="true" class="simple-slider--single">
            <div
              class="slider hide-scrollbars ${this.pxClass} flex"
              data-slider-items
            >
              ${repeat(
          this.filteredProducts,
          (product) => product.id,
          (product, index) => html`
                  <div
                    role="group"
                    aria-label="slide ${index + 1} of ${this.filteredProducts.length}"
                    data-slider-item
                    data-slide-index="${index}"
                    style="flex: 0 0 100%;"
                  >
                    <div style="padding: 0 20px;">
                      <div class="accordion-card-item">
                        <mini-product-card
                          class="product-card"
                          role="group"
                          aria-label="${window.variantStrings.product}"
                          hydrate
                          product-id="${product.product_id}"
                          product-handle="${product.url.split('/').slice(-1)}"
                          url-postfix=""
                          data-product-href="${product.url}"
                          data-product-image-primary="${product.image_url}"
                          data-product-image-secondary="${product
              .alternate_image_urls[0] || ''}"
                          data-product-title="${product.name}"
                          data-product-description=""
                          data-product-price="${product.price}"
                          data-atc-label="${this['atc-label']}"
                          data-edit-variant-label="${this[
            'edit-variant-label'
            ]}"
                        ></mini-product-card>
                      </div>
                    </div>
                  </div>
                `
        )}
            </div>
            <div class="${this.pxClass}">
              <div
                class="slider-controls slider-controls--default"
              >
                <button
                  class="no-styles slider-prev no-styles"
                  type="button"
                  data-slider-back=""
                  tabindex="0"
                  aria-label="Previous slide"
                >
                  <span class="icon">
                    <svg
                      aria-hidden="true"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.2109 7.336L11.7708 7.77603L7.26303 12.2838L5.76042 10.7812L9.18957 7.35209L0.125667 7.40036L0.125667 6.27341L0.125667 5.14648L9.18967 5.19487L5.76042 1.76563L7.26302 0.263026L11.7708 4.77083L13.2734 6.27343L13.2734 6.27343L12.2109 7.33599L12.2109 7.336L12.2109 7.336Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span>
                </button>
                <ul
                  class="list-unstyled flex align-center jcc slider-dots"
                  data-slider-dots
                >
                  ${repeat(
          this.filteredProducts,
          (product) => product.id,
          (_, index) => html`<li>
                      <button class="simple-slider-dot" data-index="${index}">
                        <span class="visually-hidden">Go to slide ${index + 1}</span>
                        <svg
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="28px"
                          height="28px"
                          style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <g>
                            <path
                              style="opacity:0.849"
                              fill="#000000"
                              d="M 13.5,-0.5 C 14.1667,-0.5 14.8333,-0.5 15.5,-0.5C 17.4342,5.76653 21.4342,10.0999 27.5,12.5C 27.5,13.1667 27.5,13.8333 27.5,14.5C 21.3747,16.9554 17.3747,21.2887 15.5,27.5C 14.8333,27.5 14.1667,27.5 13.5,27.5C 11.2678,20.9327 6.93448,16.266 0.5,13.5C 6.97827,10.6932 11.3116,6.02652 13.5,-0.5 Z"
                            />
                          </g>
                        </svg>
                      </button>
                    </li>`
        )}
                </ul>
                <button
                  class="no-styles slider-next no-styles"
                  type="button"
                  data-slider-next=""
                  tabindex="0"
                  aria-label="Next slide"
                >
                  <span class="icon">
                    <svg
                      aria-hidden="true"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.2109 7.336L11.7708 7.77603L7.26303 12.2838L5.76042 10.7812L9.18957 7.35209L0.125667 7.40036L0.125667 6.27341L0.125667 5.14648L9.18967 5.19487L5.76042 1.76563L7.26302 0.263026L11.7708 4.77083L13.2734 6.27343L13.2734 6.27343L12.2109 7.33599L12.2109 7.336L12.2109 7.336Z"
                        fill="black"
                      ></path>
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </simple-slider>
        </div>
      </div>
    `
  }

  static styles = [visuallyHidden, css``]
}

customElements.define('hh-cart-nosto-slideshow', CartNostoSlideshow)
